// extracted by mini-css-extract-plugin
export default {"title":"DetallesTable_title__qOzw2"};